import { ActivityProgress, Streak } from '@/types';

export function calculateStreak(progress: ActivityProgress[]): Streak {
  if (progress.length === 0) {
    return {
      activityId: '',
      current: 0,
      longest: 0,
      lastCompletedDate: null
    };
  }

  const sortedProgress = progress.sort((a, b) => 
    new Date(b.completedAt).getTime() - new Date(a.completedAt).getTime()
  );

  const activityId = sortedProgress[0].activityId;
  const today = new Date();
  const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
  
  let current = 0;
  let longest = 0;
  let tempStreak = 0;
  let lastCompletedDate = null;

  const completedDates = new Set(
    sortedProgress.map(p => new Date(p.completedAt).toDateString())
  );

  const dates = Array.from(completedDates).sort((a, b) => 
    new Date(b).getTime() - new Date(a).getTime()
  );

  if (dates.length > 0) {
    lastCompletedDate = new Date(dates[0]);
    
    const lastDate = new Date(dates[0]);
    const isToday = lastDate.toDateString() === today.toDateString();
    const isYesterday = lastDate.toDateString() === yesterday.toDateString();
    
    if (isToday || isYesterday) {
      current = 1;
      let checkDate = new Date(lastDate);
      
      for (let i = 1; i < dates.length; i++) {
        const prevDate = new Date(dates[i]);
        const expectedDate = new Date(checkDate.getTime() - 24 * 60 * 60 * 1000);
        
        if (prevDate.toDateString() === expectedDate.toDateString()) {
          current++;
          checkDate = prevDate;
        } else {
          break;
        }
      }
    }
  }

  tempStreak = 1;
  for (let i = 1; i < dates.length; i++) {
    const currentDate = new Date(dates[i]);
    const prevDate = new Date(dates[i - 1]);
    const daysDiff = Math.floor((prevDate.getTime() - currentDate.getTime()) / (24 * 60 * 60 * 1000));
    
    if (daysDiff === 1) {
      tempStreak++;
    } else {
      longest = Math.max(longest, tempStreak);
      tempStreak = 1;
    }
  }
  longest = Math.max(longest, tempStreak, current);

  return {
    activityId,
    current,
    longest,
    lastCompletedDate
  };
}

export function canCompleteToday(lastCompletedDate: Date | null): boolean {
  if (!lastCompletedDate) return true;
  
  const today = new Date().toDateString();
  const lastCompleted = new Date(lastCompletedDate).toDateString();
  
  return today !== lastCompleted;
}

export function calculateLevel(totalPoints: number): number {
  return Math.floor(totalPoints / 100) + 1;
}

export function getPointsForNextLevel(totalPoints: number): number {
  const currentLevel = calculateLevel(totalPoints);
  const pointsNeeded = currentLevel * 100;
  return pointsNeeded - totalPoints;
}